/**
 * Typed environment config — the single chokepoint for `import.meta.env`.
 * Per the RFrame CoP, no other module may read import.meta.env directly;
 * everything imports from `@config`.
 */
const env = import.meta.env;

export const config = {
  /** Deploy environment name (gamma | delta | zeta | prod). */
  env: (env.VITE_ENV ?? 'gamma') as string,
  /** Git SHA injected by `rframe build`. */
  gitSha: (env.VITE_GIT_SHA ?? 'dev') as string,
  /** Sentry DSN; empty string disables Sentry. */
  sentryDsn: (env.VITE_SENTRY_DSN ?? '') as string,
  /**
   * targetOrigin for postMessage back to the embedding ESS page.
   * '*' per the integration spec default; lock to the ESS origin per env
   * once known.
   */
  parentOrigin: (env.VITE_PARENT_ORIGIN ?? '*') as string,
  /** Base URL for RTK Query (unused by the capture flow — portal makes no API calls). */
  apiBaseUrl: (env.VITE_API_BASE_URL ?? '/api') as string,
} as const;

export type AppConfig = typeof config;
